/**
 * Ref-counted body scroll lock — üst üste açılan Drawer/Modal'larda güvenli.
 *
 * Eski yaklaşımda her overlay kendi `previousOverflow`'unu yakalayıp geri koyuyordu.
 * İki overlay üst üste açılıp LIFO-dışı kapanınca body `overflow:hidden` TAKILI kalıyordu
 * (founder 2026-06-17: onay detay drawer'ı + fiş önizleme drawer'ı birlikte açılınca
 * onaylama detay drawer'ını kapatıyor, ardından fiş drawer'ı kapanırken body'i tekrar
 * 'hidden'a çekiyordu → Çalışanlar/Organizasyon sayfaları scroll edemiyordu).
 *
 * Sayaç ile: yalnız 0→1 geçişte kilitle, yalnız 1→0 geçişte serbest bırak. Açılış/kapanış
 * sırasından bağımsız, sızıntısız.
 */
let lockCount = 0;
let savedOverflow: string | null = null;

export function lockBodyScroll(): void {
  if (typeof document === 'undefined') return;
  if (lockCount === 0) {
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  lockCount += 1;
}

export function unlockBodyScroll(): void {
  if (typeof document === 'undefined') return;
  if (lockCount === 0) return;
  lockCount -= 1;
  if (lockCount === 0) {
    document.body.style.overflow = savedOverflow ?? '';
    savedOverflow = null;
  }
}
